import { Component, Input } from '@angular/core';

/**
 * The ⓘ beside a setting in the module panel. The explanation lives in a tooltip rather than in a
 * line of text under the control: a module can have a dozen settings, and a sentence under each one
 * made the list twice as long as the settings themselves.
 *
 * A button rather than a bare icon so it is reachable by keyboard -- the tooltip opens on focus as
 * well as hover -- and the same text is the accessible name, so nothing is only available to a
 * pointer.
 */
@Component({
  selector: 'or-config-hint',
  standalone: false,
  template: `
    <button type="button"
            class="config-hint"
            [tooltip]="text"
            container="body"
            containerClass="config-hint-tooltip"
            [attr.aria-label]="text">
      <i class="fas fa-circle-info" aria-hidden="true"></i>
    </button>
  `,
  styles: [`
    :host { display: inline-flex; }

    .config-hint {
      background: none;
      border: 0;
      padding: 0;
      line-height: 1;
      color: var(--nav-grey3);
      font-size: 12px;
    }

    .config-hint:hover,
    .config-hint:focus-visible {
      color: var(--nav-secondary);
    }
  `],
})
export class ReportConfigHintComponent {
  // The tooltip is drawn against <body>, outside this component's styles, so its look -- the width
  // cap above all, since some of these run to three sentences -- is in themes/theme.scss under
  // .config-hint-tooltip.
  @Input({ required: true }) text = '';
}
